// @ts-check

/**
 * @file Formats date-like values for display.
 */

/**
 * Formats a date-like value for display.
 * @param {Date | string | null | undefined} value Date or ISO string.
 * @returns {string} Locale-formatted date or `-` when missing/invalid.
 */
export default function formatDate(value) {
  if (!value) return "-"
  const dateValue = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(dateValue.getTime())) return "-"
  return dateValue.toLocaleDateString()
}
